import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RightSidebarListItem from "./RightSidebarListItem";
import { GlobalStateContext } from "../GlobalStates";
import useSideBarList from "../../hooks/helperData/useSideBarList";
import useUserSideBarList from "../../hooks/helperData/useUserSideBarList";
import {
    APP_FLAVOR_ORGAN,
    isOrganAccount,
    isStandaloneDisplay,
} from "../../helperData/appFlavor";

const RightSidebarList = ({ closeSidebar }) => {
    const { currentPanel } = useContext(GlobalStateContext);
    const { auth } = useContext(GlobalStateContext);
    const { t } = useTranslation();
    const sideBarList = useSideBarList();
    const userSideBarList = useUserSideBarList();
    const currentPanelList =
        currentPanel === "organ" ? sideBarList : userSideBarList;

    const [refresher, setRefresher] = useState(false);

    const [newMessagesCompany, setNewMessagesCompany] = useState(0);

    const navlinkClick = () => {
        setRefresher(!refresher);
        closeSidebar();
    };

    const canSwitchApp = isOrganAccount(auth) && !isStandaloneDisplay();
    const otherApp =
        currentPanel === APP_FLAVOR_ORGAN
            ? {
                  to: "/dashboard/user/dashboard",
                  label: t("AppNav.SwitchToUser"),
              }
            : {
                  to: "/dashboard/messages/organ",
                  label: t("AppNav.SwitchToOrgan"),
              };

    return (
        <ul className="sidebar_list  list-unstyled">
            {currentPanelList.map((item, index) => (
                <RightSidebarListItem
                    item={item}
                    key={"link-" + index}
                    onClick={navlinkClick}
                    newMessagesCompany={newMessagesCompany}
                />
            ))}
            {canSwitchApp && (
                <li className="sidebar-app-switch">
                    <NavLink to={otherApp.to} onClick={navlinkClick}>
                        {otherApp.label}
                    </NavLink>
                </li>
            )}
        </ul>
    );
};

export default RightSidebarList;
